import { clevertapEvent } from 'utils/clevertap';

const EVENTS = {
  navigate: 'Live Stream Event Detail Viewed',
};

const ACTIONS = {
  shareButtonSelected: 'Live Stream Share Button Selected',
  setReminder: 'Live Stream Set reminder Selected',
};

const LivestreamAnalytics = {
  Navigate: {
    ViewPage: (params) => {
      clevertapEvent(EVENTS.navigate, params);
    },
  },
  Action: {
    shareButtonSelected: (params) => {
      clevertapEvent(ACTIONS.shareButtonSelected, params);
    },
    setReminder: (params) => {
      clevertapEvent(ACTIONS.setReminder, params);
    },
  },
};

export default LivestreamAnalytics;
